import React from 'react';
import {
  OurVisionMissionWrapper,
  OurVisionMissionContainer,
  OurVisionMissionColumn,
  OurVisionMissionRow,
  OurVisionMissionTitle,
  OurVisionMissionDescription,
  OurVisionMissionSeperator,
} from '../styles/OurVisionMission.styled';

export default function OurVisionMission({ data, id, dir }) {
  return (
    <OurVisionMissionWrapper id={id} className="smoothed">
      <OurVisionMissionContainer>
        <OurVisionMissionRow>
          <OurVisionMissionColumn>
            <OurVisionMissionTitle dir={dir}>{data.columnTitle1}</OurVisionMissionTitle>
            <OurVisionMissionDescription>{data.columnDescription1}</OurVisionMissionDescription>
          </OurVisionMissionColumn>
          <OurVisionMissionSeperator />
          <OurVisionMissionColumn>
            <OurVisionMissionTitle dir={dir}>{data.columnTitle2}</OurVisionMissionTitle>
            <OurVisionMissionDescription>{data.columnDescription2}</OurVisionMissionDescription>
          </OurVisionMissionColumn>
        </OurVisionMissionRow>
      </OurVisionMissionContainer>
    </OurVisionMissionWrapper>
  );
}
